import React from "react";

export default function NewYearFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-4ne2{fill:#458671}.cls-4ne3{fill:#f04f26}.cls-4ne4{fill:#db3919}.cls-4ne5{fill:#09594a}.cls-4ne6{fill:#114e3a}"
            }
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_7"
          data-name="\u0421\u043B\u043E\u0439 7"
        >
          <path
            d="M359.62 440.33h1359.99v1359.99H359.62z"
            style={{
              fill: "#fff",
              stroke: "#458671",
              strokeMiterlimit: 10,
              strokeWidth: "16.45px",
            }}
          />
          <path
            d="M939.6 488.15c-.21-9.09-3.42-76.67-85.67-108.69-26.51-10.32-67.46-19.39-80.8-11.72-22.4 12.88 45.53 66 32.42 71.08-14.17 5.53-84.73-60-171.69-60.58-38.74-.25-77.76 12.42-76.93 24.47 1.42 20.57 119 38.93 116.62 44.46-2.48 5.77-125.55-25.89-184.84 1.83-21.61 10.09-37.12 29.19-25.5 39.68 28.66 25.85 211.64-10.27 220.94 2.31 6.83 9.24-91.87 29-83.28 48.25 5.38 12.07 50.69 19.24 80.72 19.72 29.71.48 51.6-5.47 67.47-9.91 45.07-12.62 65.72-30.31 70.41-28.29 8.23 3.55-65.77 53.89-42 71.38 12.32 9.06 47.71 7 70.06 2.44 70.47-14.36 92.91-69.69 92.07-106.43Z"
            className="cls-4ne2"
          />
          <path
            d="M1046.85 1807.39c1.48 12.61-2 23.5-3.68 28.68-16.17 49.34-70 51-115.42 51.51-50.23.58-105.53 1.23-114.47-39.8-5-23.07 5.69-54.3 12.77-74.91 3.39-9.89 12.12-35.3 26.06-50.67 11.29-12.44 26.77-19.17 124.36 25.7 46.82 21.52 67.4 34.17 70.38 59.49Z"
            className="cls-4ne3"
          />
          <path
            d="M1018.1 1784.57c-.18 3.46-6 5.31-98.86 9.37-51 2.22-70.31 2.59-74.27-13.27-3.39-13.59 5.42-35.4 15.85-45.87 16.17-16.21 34.35-3.29 66.46 12.32 61.27 29.79 91.24 29.52 90.82 37.45Z"
            className="cls-4ne4"
          />
          <path
            d="M1047.57 1807.39c-1.48 12.61 2 23.5 3.67 28.68 16.17 49.34 70 51 115.42 51.51 50.23.58 105.54 1.23 114.48-39.8 5-23.07-5.7-54.3-12.78-74.91-3.39-9.89-12.11-35.3-26.06-50.67-11.28-12.44-26.77-19.17-124.36 25.7-46.82 21.52-67.4 34.17-70.37 59.49Z"
            className="cls-4ne3"
          />
          <path
            d="M1076.31 1784.57c.18 3.46 6 5.31 98.87 9.37 51 2.22 70.3 2.59 74.26-13.27 3.4-13.59-5.41-35.4-15.85-45.87-16.17-16.21-34.35-3.29-66.46 12.32-61.27 29.79-91.24 29.52-90.82 37.45Z"
            className="cls-4ne4"
          />
          <path
            d="M1078.89 1820.1c-.13 8.39-.71 47.14-12.93 51.5-5.55 2-8.38-4.88-19.55-5.07s-14.11 6.51-19.56 4.29c-11.28-4.59-11.33-39-11.35-50.72 0-23.93 3.92-60.23 14.51-62.42 5-1 7.2 6.52 16.08 7 9.6.54 12.65-8 18.29-6.63 10.91 2.6 14.87 38.02 14.51 62.05Z"
            className="cls-4ne4"
          />
          <path
            d="M1041 530.64c6.21-8.64 51-73.62 5.29-140.38-14.73-21.51-42.32-48.27-58.75-47-27.62 2.13-8.57 82.31-23 81.28-15.64-1.11-28.11-94.18-99.8-133.44-31.94-17.49-73.17-23-80.94-11.26-13.27 20 71.3 89.62 65.45 93.76-6.11 4.32-85.92-80.29-154.47-80.66-25-.14-51.26 10.91-49 25.95 5.6 37.08 182.65 84.61 181.52 100.59-.83 11.74-96.49-13.68-102.9 8.28-4 13.74 28.51 40.67 53.06 54.51C801.7 496 824 500.1 840.3 503c46.22 8.22 75.76.77 78.22 4.76 4.33 7-92.35 21.38-84.89 48.44 3.85 14 34.64 27.81 56.36 33.5 68.41 17.89 125.88-24.13 151.01-59.06Z"
            className="cls-4ne5"
          />
          <path
            d="M1114 488.15c.2-9.09 3.41-76.67 85.67-108.69 26.5-10.32 67.46-19.39 80.79-11.72 22.41 12.88-45.52 66-32.42 71.08 14.18 5.53 84.73-60 171.69-60.58 38.74-.25 77.76 12.42 76.93 24.47-1.42 20.57-119 38.93-116.61 44.46 2.48 5.77 125.57-25.89 184.83 1.78 21.61 10.09 37.12 29.19 25.5 39.68-28.65 25.85-211.64-10.27-220.93 2.31-6.84 9.24 91.86 29 83.27 48.25-5.38 12.07-50.69 19.24-80.72 19.72-29.7.48-51.59-5.47-67.47-9.91-45.07-12.62-65.72-30.31-70.4-28.29-8.23 3.55 65.77 53.89 42 71.38-12.32 9.06-47.7 7-70.06 2.44-70.48-14.31-92.95-69.64-92.07-106.38Z"
            className="cls-4ne2"
          />
          <path
            d="M1037.25 522.71c-13.59-7.41-113.5-63.63-109.92-148.11 1.15-27.22 13.32-63.8 33.3-67.23 33.58-5.77 70.79 85.25 86.77 79.94 17.29-5.74-37.07-108.59 16.95-171.34 24.06-27.95 67.79-45.8 85.44-35.59 30.14 17.43-16.34 116.32-6.5 119 10.28 2.83 40.17-110.63 119.31-131 28.86-7.43 67.46-3.3 75.94 13.39 20.92 41.16-149 143.42-135.91 160.12 9.64 12.28 101.66-42.69 125.33-21.15 14.81 13.48-3 51.67-21.17 73.57-18 21.66-40.81 32.59-57.53 40.42-47.47 22.22-87.19 22.9-87.1 27.87.17 8.73 122.79-4.12 134.16 26.89 5.89 16.06-19.56 39.75-40.52 52.14-66.01 39.05-163.66 11-218.55-18.92Z"
            className="cls-4ne5"
          />
          <path
            d="M772.81 183.64c7.25 6.15 14.53 12.27 21.64 18.54l5.34 4.69 5.28 4.75c3.5 3.18 7 6.32 10.5 9.52q20.85 19.19 40.69 39.14l9.74 10.08 4.88 5 4.78 5.11 9.55 10.22 9.35 10.36 4.67 5.18 4.56 5.25L913 322l8.9 10.63 4.46 5.32c1.48 1.78 2.9 3.58 4.35 5.38l8.7 10.75c2.9 3.59 5.66 7.25 8.49 10.87s5.72 7.23 8.44 10.91l8.24 11c1.36 1.84 2.75 3.67 4.08 5.53l4 5.59 7.83 11.22q7.59 11.34 14.84 22.84c4.73 7.7 9.38 15.44 13.86 23.25s8.82 15.67 12.93 23.62c8.32 15.86 16 31.94 22.77 48.29l-.87.31c-9.26-15.46-18.46-30.89-27.92-46.2-4.77-7.63-9.48-15.28-14.38-22.85s-9.73-15.17-14.76-22.67l-15.14-22.49-7.66-11.19-3.79-5.62c-1.26-1.87-2.59-3.71-3.89-5.57l-7.77-11.15c-1.27-1.87-2.6-3.71-4-5.54l-4-5.51c-2.71-3.66-5.34-7.36-8.1-11l-8.31-10.88c-1.39-1.81-2.76-3.64-4.18-5.43l-4.28-5.37-8.57-10.75-8.8-10.61-4.4-5.31-4.5-5.24-9-10.49-9.23-10.36-4.62-5.18L862 273l-9.46-10.23q-19.11-20.31-39.18-40c-3.34-3.28-6.77-6.5-10.15-9.76l-5.09-4.86-5.12-4.82c-6.83-6.47-13.86-12.79-20.84-19.14Z"
            className="cls-4ne6"
          />
          <path
            d="M898.41 312.89a511.34 511.34 0 0 1-117.09-26.76 513.59 513.59 0 0 0 117.82 20.58ZM939.86 362.22a238.4 238.4 0 0 0 33.66-80.52A235.6 235.6 0 0 1 946 364.79ZM823.8 232.43a187 187 0 0 0 10.05-70.36 187.16 187.16 0 0 1-5.85 71.29ZM1011.55 474.74a335.8 335.8 0 0 0 28.13-52.59 328.05 328.05 0 0 0 18-55.92 323.67 323.67 0 0 1-13.68 57.08 332.86 332.86 0 0 1-24.35 54.86ZM966.41 403.52a718 718 0 0 1-165.17-11.34 714.08 714.08 0 0 0 164.29 2.89Z"
            className="cls-4ne6"
          />
          <ellipse
            cx={833.45}
            cy={158.12}
            className="cls-4ne4"
            rx={16.76}
            ry={12.24}
            transform="rotate(-2.07 832.957 158.18)"
          />
          <ellipse
            cx={970.92}
            cy={281.89}
            className="cls-4ne4"
            rx={16.76}
            ry={12.24}
            transform="rotate(-2.07 970.26 281.645)"
          />
          <ellipse
            cx={1055.71}
            cy={366.37}
            className="cls-4ne4"
            rx={16.76}
            ry={12.24}
            transform="rotate(-2.07 1055.109 366.233)"
          />
          <ellipse
            cx={781.27}
            cy={285.61}
            className="cls-4ne4"
            rx={15.36}
            ry={13.36}
            transform="rotate(-24.5 786.74 290.187)"
          />
          <ellipse
            cx={772.17}
            cy={180.93}
            className="cls-4ne4"
            rx={15.88}
            ry={12.92}
            transform="rotate(-20.3 772.05 180.935)"
          />
          <ellipse
            cx={801.05}
            cy={390.35}
            className="cls-4ne4"
            rx={15.36}
            ry={13.36}
            transform="rotate(-24.43 801.031 390.343)"
          />
          <path
            d="M1223.83 277.93c-4.7 4.67-9.42 9.31-14 14.06l-3.47 3.53-3.42 3.57c-2.27 2.39-4.56 4.76-6.8 7.16q-13.49 14.4-26.19 29.28l-6.3 7.47-3.14 3.74-3.07 3.77-6.13 7.56-6 7.65-3 3.82-2.91 3.86-5.82 7.73-5.65 7.81-2.83 3.91c-.94 1.3-1.83 2.63-2.75 3.94l-5.46 7.9c-1.82 2.64-3.54 5.32-5.31 8l-2.63 4c-.88 1.33-1.76 2.67-2.59 4l-5.07 8.08c-.84 1.34-1.72 2.68-2.54 4l-2.47 4.07-5 8.11-9.8 16.29c-3.27 5.44-6.44 10.91-9.58 16.4s-6.22 11-9.31 16.52c-6.11 11.06-12 22.2-18 33.36l-.63-.19c4.17-11.73 9-23.29 14.29-34.71 2.61-5.72 5.42-11.37 8.25-17s5.88-11.22 8.93-16.79 6.34-11 9.63-16.51l5.11-8.14 2.59-4.05c.87-1.35 1.79-2.67 2.67-4l5.42-8c1.78-2.68 3.71-5.28 5.55-7.93s3.68-5.29 5.6-7.9l5.74-7.83c1-1.3 1.9-2.61 2.87-3.91l2.95-3.87 5.9-7.74 6.06-7.65 3-3.83 3.1-3.78 6.22-7.56 6.37-7.47 3.18-3.73 3.26-3.69 6.53-7.37q13.3-14.58 27.28-28.71c2.33-2.35 4.71-4.66 7.07-7l3.54-3.49 3.61-3.45c4.78-4.62 9.7-9.13 14.59-13.66Z"
            className="cls-4ne6"
          />
          <path
            d="M1138.68 367.78a359.48 359.48 0 0 0 82.45-17.61 357.59 357.59 0 0 1-81.7 22ZM1107.78 410a168.91 168.91 0 0 1-22.57-58 171.91 171.91 0 0 0 26.77 56ZM1186.17 314.12a133.12 133.12 0 0 1-6.76-50.21 133 133 0 0 0 9.72 49.44ZM1059.93 492a239.35 239.35 0 0 1-19.24-38.11 231.69 231.69 0 0 1-11.81-40 234.51 234.51 0 0 0 14.83 39 240.87 240.87 0 0 0 21.83 36.41ZM1095.07 431.93A504 504 0 0 0 1211 425.6a505.58 505.58 0 0 1-116.24 12.32Z"
            className="cls-4ne6"
          />
          <ellipse
            cx={1179.54}
            cy={261.11}
            className="cls-4ne4"
            rx={8.65}
            ry={11.86}
            transform="rotate(-89.01 1179.56 261.108)"
          />
          <ellipse
            cx={1087.05}
            cy={352.12}
            className="cls-4ne4"
            rx={8.65}
            ry={11.86}
            transform="rotate(-88.9 1088.974 350.975)"
          />
          <ellipse
            cx={1030.3}
            cy={414}
            className="cls-4ne4"
            rx={8.65}
            ry={11.86}
            transform="rotate(-89.01 1030.318 413.998)"
          />
          <ellipse
            cx={1221.15}
            cy={349.81}
            className="cls-4ne4"
            rx={9.39}
            ry={10.93}
            transform="rotate(-66.05 1221.24 349.777)"
          />
          <ellipse
            cx={1223.68}
            cy={275.63}
            className="cls-4ne4"
            rx={9.09}
            ry={11.29}
            transform="rotate(-70.59 1223.75 275.6)"
          />
          <ellipse
            cx={1211.08}
            cy={424.3}
            className="cls-4ne4"
            rx={9.39}
            ry={10.93}
            transform="rotate(-66.05 1211.173 424.281)"
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
